import { TaskDefinition } from '../../types/task'

type TaskStatus = TaskDefinition['status']

export const STATUS_LABELS: Record<TaskStatus, string> = {
  REQUESTED: 'Requested',
  REJECTED: 'Rejected',
  SCHEDULED: 'Scheduled',
  IN_PROGRESS: 'In Progress',
  DELAYED: 'Delayed',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
}

// Kept in sync with TaskStatusDropdown's badge colours so the status reads the same everywhere.
export const STATUS_COLORS: Record<TaskStatus, string> = {
  REQUESTED: '#FFE373',
  REJECTED: '#FF9090',
  SCHEDULED: '#4ABED1',
  IN_PROGRESS: '#92E663',
  DELAYED: '#FF8484',
  COMPLETED: '#ECECEC',
  CANCELLED: '#D4D4D4',
}

export const getStatusLabel = (status: TaskStatus): string => STATUS_LABELS[status] ?? status

export const getStatusColor = (status: TaskStatus): string => STATUS_COLORS[status] ?? '#D4D4D4'

// Rounds trip progress to a whole percent clamped to 0–100, or null when there is no value.
export const formatProgressPercent = (tripProgress?: number): number | null => {
  if (tripProgress == null || Number.isNaN(tripProgress)) return null
  return Math.min(100, Math.max(0, Math.round(tripProgress)))
}

// The assigned asset id shown in the header, or '-' when the task has no vehicle assigned.
export const formatAssetId = (task: TaskDefinition): string =>
  task.assignedVehicle?.id != null ? String(task.assignedVehicle.id) : '-'
